import { SEMANTIC_TAG, TypographySize } from 'mm-theme-configuration/dist/consts';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';
import { TranslatedFontSize } from '../../../../../theming/fontSizeTranslator';

export const componentConfigThemeKey = 'headerWithSubMenus';

export interface HeaderWithSubMenusThemeProps {
    firstRowBackgroundColor: string;
    secondRowBackgroundColor: string;
    firstRowHeightInSmallScreen: number;
    firstRowHeightInMediumScreen: number;
    firstRowHeightInLargeScreen: number;
    secondRowHeightInSmallScreen: number;
    secondRowHeightInMediumScreen: number;
    logoHeightInSmallScreen: number;
    logoHeightInMediumScreen: number;
    logoHeightInLargeScreen: number;
    linkSemanticTag: SEMANTIC_TAG;
    linkFontSizeLarge: TypographySize;
    linkFontSizeMedium: TypographySize;
    linkFontSizeSmall: TypographySize;
    linkColorTypeNormal: string;
    linkColorTypeHover: string;
    linkColorTypeActive: string;
    linkDropdownIconColor: string;
    socialMediaIconColor: string;
    editionsIconColor: string;
    verticalGapInSmallScreen: number;
    verticalGapInMediumScreen: number;
    verticalGapInLargeScreen: number;
    boxShadow: string;
    baseUnit: BaseUnit;
    fontSizesStyles: TranslatedFontSize;
    idleColor: string;
    activeStateColor: string;
    hoverStateColor: string;
    editionsSeparatorColor: string;
    editionsMenuBackgroundColor: string;
    subMenuLinksBackgroundColor: string;
    subMenuLinksSecondLevelBackgroundColor: string;
}
